<template>
  <PageWrapper
    backIcon="arrow-right"
    :maxWidth="5000"
    :handleBack="goToCenterExecuteCases"
  >
    <template #title-area>
      <div class="flex-start">
        <span class="color-complementary-400 font-size-16 margin-left-8">
          {{ pathOr("", ["name"], currentExercise) }}
        </span>
      </div>
    </template>
    <template #left-header>
      <div
        class="flex mobile-flex-direction-column tablet-flex-direction-column"
      >
        <div
          class="border--solid border--complementary-50 border-radius-8 font-size-14 font-weight-500 cursor--pointer padding-x-12 padding-y-8 flex-center background-surface color-complementary-400 is-hover min-width-152 mobile-width-percent-100 tablet-width-percent-100 margin-left-8 mobile-margin-bottom-8 tablet-margin-bottom-8"
          @click="handleOpenExerciseDescriptionModal"
        >
          <span>
            <mdicon name="help-circle-outline" size="20" />
          </span>
          <span class="margin-right-8">{{ $lang.exerciseDescription }}</span>
        </div>

        <PersonContentAudio
          v-if="hasVoiceRecording"
          rowClass="width-percent-100 mobile-margin-bottom-8 tablet-margin-bottom-8"
          :exerciseName="pathOr('', ['name'], currentExercise)"
          :candidateName="pathOr('', ['name'], candidateData)"
          :candidateId="pathOr('', ['id'], candidateData)"
          :assessorId="pathOr('', ['id'], assessorData)"
        />
      </div>
      <CompetencyAccessError
        v-if="message"
        rowClass="width-percent-100 desktop-none"
        :detailMessage="message"
      />
    </template>
    <Tabs class="margin-top-16" :tabs="tabs" @getCurrentTab="getCurrentTab">
      <template #tab-0> <TabOneContent /> </template>
      <template #tab-1> <TabTwoContent /> </template>
      <template #tab-2> <TabThreeContent :isReadonly="!!message" /> </template>
      <template #left-area>
        <div class="flex-end mobile-none tablet-none">
          <CompetencyAccessError
            v-if="message"
            rowClass="width-percent-100 desktop-margin-left-8"
            :detailMessage="message"
          />
        </div>
      </template>
    </Tabs>
    <Modal
      :show="isExerciseDescriptionModal"
      :title="$lang.exerciseDescription"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="false"
      @close="handleCloseExerciseDescriptionModal"
    >
      <template #body>
        <div
          class="color-complementary-300 line-height-24"
          v-html="pathOr('', ['description'], currentExercise)"
        ></div>
      </template>
    </Modal>
  </PageWrapper>
</template>

<script>
import { PageWrapper, Tabs, Modal } from "@/components/re-design";
import TabOneContent from "./TabOneContent.vue";
import TabTwoContent from "./TabTwoContent.vue";
import TabThreeContent from "./TabThreeContent.vue";
import PersonContentAudio from "./components/PersonContentAudio.vue";
import CompetencyAccessError from "./components/CompetencyAccessError.vue";
import { computed, onMounted, provide, ref } from "vue";
import { pathOr, includes } from "ramda";
import { generateCurrentRoute, generateError, goToRoute } from "@/shared/utils";
import { getCenterExecuteCasePersons } from "@/modules/kanoon/services";
export default {
  components: {
    PageWrapper,
    Tabs,
    Modal,
    TabOneContent,
    TabTwoContent,
    TabThreeContent,
    PersonContentAudio,
    CompetencyAccessError,
  },
  setup() {
    const tabs = [
      {
        text: "نمره دهی شایستگی",
      },
      {
        text: "مرورکلی",
      },
      {
        text: "محتوای شرکت کننده",
      },
    ];
    const currentTab = ref(null);
    const getCurrentTab = (item) => (currentTab.value = item);
    provide(
      "CURRENT_TAB",
      computed(() => currentTab.value)
    );

    const currentCenterExecuteId = generateCurrentRoute([
      "params",
      "centerExecuteId",
    ]);
    // handle back button
    const goToCenterExecuteCases = () => {
      const name = "center-execute-cases";
      const params = { centerExecuteId: currentCenterExecuteId };
      goToRoute(name, params, {}, false);
    };

    const currentExercise = ref(null);
    const currentCaseStatus = ref(null);
    const userExecutiveRoleId = ref(null);
    const assessorData = ref(null);
    const candidateData = ref(null);
    const isCompetencyScoringMethodByAssessor = ref(null);
    const isIndicatorVerificationMethodByAssessor = ref(null);
    const hasVoiceRecording = ref(false);
    const hasSample = ref(false);
    const getPersons = async () => {
      try {
        const centerExecuteId = generateCurrentRoute([
          "params",
          "centerExecuteId",
        ]);
        const caseId = generateCurrentRoute(["params", "caseId"]);
        const response = await getCenterExecuteCasePersons(
          centerExecuteId,
          caseId
        );
        const {
          assessor,
          candidate,
          caseStatus,
          executiveRoleId,
          exercise,
          getIsIndicatorVerificationMethodByAssessor,
          getIsCompetencyScoringMethodByAssessor,
          getHasVoiceRecording,
          getHasSample,
        } = response;
        currentExercise.value = exercise;
        currentCaseStatus.value = caseStatus;
        userExecutiveRoleId.value = executiveRoleId;
        assessorData.value = assessor;
        candidateData.value = candidate;
        isIndicatorVerificationMethodByAssessor.value =
          getIsIndicatorVerificationMethodByAssessor;
        isCompetencyScoringMethodByAssessor.value =
          getIsCompetencyScoringMethodByAssessor;
        hasVoiceRecording.value = getHasVoiceRecording;
        hasSample.value = getHasSample;
      } catch (error) {
        generateError(error);
      }
    };
    onMounted(async () => {
      await getPersons();
      calcPermissions();
    });

    const isExerciseDescriptionModal = ref(false);
    const handleOpenExerciseDescriptionModal = () =>
      (isExerciseDescriptionModal.value = true);
    const handleCloseExerciseDescriptionModal = () =>
      (isExerciseDescriptionModal.value = false);

    const message = ref(null);
    const allItemPermissions = ref([]);
    const calcPermissions = () => {
      const caseStatusId = pathOr(null, ["id"], currentCaseStatus.value);
      /*
      وضعیت پرونده: caseStatusId
      1: در حال بررسی ارزیاب
      2: در حال بررسی ناظر کیفی
      3: در حال بررسی مدیر کانون
      4: جمع‌بندی
      5: پایان فرایند ارزیابی
      6: تایید ویراستار
      7: درحال بازبینی ارزیاب
      8: درحال بازبینی ناظر کیفی

      نقش کانونی: userExecutiveRoleId
      1: شرکت کننده
      2: ارزیاب
      3: مدیر کانون
      4: ناظر کیفی
      5: واشاپر
      6: تسهیلگر
      7: ویراستار
    */
      /*
        ERROR_ADD => درج خطا
        ERROR_REMOVE => حذف خطا
        ERROR_CAPTION_EDIT => ویرایش عنوان خطا
        ERROR_DESCRIPTION_EDIT => ویرایش توضیحات خطا

        SAMPLE_ADD => درج شاهد رفتاری
        SAMPLE_REMOVE => حذف شاهد رفتاری
        SAMPLE_EDIT => ویرایش شاهد رفتاری

        EVIDENCE_SELECT => انتخاب مصداق

        INDICATOR_STATUS => وضعیت نشانگر
        INDICATOR_SUGGESTION_SCORE => امتیاز پیشنهادی درصفحه نشانگر
        INDICATOR_FINAL_SCORE => امتیاز نهایی درصفحه نشانگر
        INDICATOR_DESCRIPTION => توضیحات درصفحه نشانگر

        OVERVIEW_EXERCISE =>  مرور کلی

        AUDIO_RECORD =>  ضبط صدا
      */

      if (
        includes(userExecutiveRoleId.value, [2, 3]) && // ارزیاب یا مدیر
        includes(caseStatusId, [1, 7]) // وضعیت ارزیاب
      ) {
        allItemPermissions.value = [
          "ERROR_DESCRIPTION_EDIT",
          "SAMPLE_ADD",
          "SAMPLE_REMOVE",
          "SAMPLE_EDIT",
          "EVIDENCE_SELECT",
          "INDICATOR_STATUS",
          "INDICATOR_FINAL_SCORE",
          "INDICATOR_SUGGESTION_SCORE",
          "INDICATOR_DESCRIPTION",
          "OVERVIEW_EXERCISE",
          "AUDIO_RECORD",
        ];
      }

      if (
        includes(userExecutiveRoleId.value, [4]) && // ناظر کیفی
        includes(caseStatusId, [2, 8]) // وضعیت ناظر کیفی
      ) {
        allItemPermissions.value = [
          "ERROR_ADD",
          "ERROR_REMOVE",
          "ERROR_CAPTION_EDIT",
          "ERROR_DESCRIPTION_EDIT",
        ];
      }

      if (userExecutiveRoleId.value === 3) {
        // مدیر کانون
        allItemPermissions.value = [
          "ERROR_ADD",
          "ERROR_REMOVE",
          "ERROR_CAPTION_EDIT",
          "ERROR_DESCRIPTION_EDIT",
          "SAMPLE_ADD",
          "SAMPLE_REMOVE",
          "SAMPLE_EDIT",
          "EVIDENCE_SELECT",
          "INDICATOR_STATUS",
          "INDICATOR_FINAL_SCORE",
          "INDICATOR_SUGGESTION_SCORE",
          "INDICATOR_DESCRIPTION",
          "OVERVIEW_EXERCISE",
          "AUDIO_RECORD",
        ];
      }

      if (caseStatusId === 4) {
        // جمع‌بندی
        allItemPermissions.value = [];
        message.value =
          "به دلیل تایید کانون (مرحله جمع بندی) امکان ویرایش داده‌ وجود ندارد";
      }

      if (!userExecutiveRoleId.value && caseStatusId !== 4) {
        allItemPermissions.value = [];
        message.value =
          "امکان ویرایش داده‌های پرونده‌های کانون برای شما وجود ندارد فقط افرادی که در این پرونده نقش دارند می توانند داده‌های پرونده را ویرایش کنند";
      }

      if (
        userExecutiveRoleId.value === 2 && // ارزیاب
        !includes(caseStatusId, [1, 7]) // وضعیت ارزیاب نباشد
      ) {
        allItemPermissions.value = [];
        message.value =
          "پرونده در وضعیت ویرایش برای نقش شما نمیباشد لذا فقط امکان مشاهده آنرا دارید.";
      }

      if (
        userExecutiveRoleId.value === 4 && // ناظر کیفی
        !includes(caseStatusId, [2, 8]) // وضعیت ناظر کیفی نباشد
      ) {
        allItemPermissions.value = [];
        message.value =
          "پرونده در حال بررسی ناظر کیفی نمی باشد لذا امکان ویرایش برای شما وجود ندارد";
      }
    };
    // check when item
    const hasItemPermission = (items = []) => {
      const allowItems = allItemPermissions.value;
      return items.some((item) => includes(item, allowItems));
    };
    provide("hasItemPermission", hasItemPermission);
    provide(
      "CURRENT_CASE_STATUS",
      computed(() => currentCaseStatus.value)
    );
    provide(
      "CURRENT_USER_EXECUTIVE_ROLE_ID",
      computed(() => userExecutiveRoleId.value)
    );
    provide(
      "ASSESSOR_DATA",
      computed(() => assessorData.value)
    );
    provide(
      "CANDIDATE_DATA",
      computed(() => candidateData.value)
    );
    provide(
      "CENTER_EXECUTE_ID",
      computed(() => currentCenterExecuteId)
    );
    provide(
      "CASE_ID",
      computed(() => generateCurrentRoute(["params", "caseId"]))
    );
    provide(
      "IS_INDICATOR_VERIFICATION_METHOD_By_ASSESSOR",
      computed(() => isIndicatorVerificationMethodByAssessor.value)
    );
    provide(
      "IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR",
      computed(() => isCompetencyScoringMethodByAssessor.value)
    );
    provide(
      "HAS_SAMPLE",
      computed(() => hasSample.value)
    );
    provide(
      "VIEW_ONLY",
      computed(() => !!message.value)
    );

    // return data to be used in template
    return {
      pathOr,
      tabs,
      getCurrentTab,
      currentExercise,
      candidateData,
      assessorData,
      isExerciseDescriptionModal,
      handleOpenExerciseDescriptionModal,
      handleCloseExerciseDescriptionModal,
      message,
      goToCenterExecuteCases,
      hasVoiceRecording,
    };
  },
};
</script>
